export default __webpack_public_path__ + "static/media/434.2adf7b77.gif";